import {
  GET_BG_WALLET_LIST,
  GET_BG_WALLET_ADD_ON,
  GET_BG_WALLET_TRANSACTIONS,
  Add_BG_WALLET,
  Add_BG_WALLET_PANELTY,
  GET_BG_WALLET_STATUS,
  GET_BG_TRANSACTION_STATUS,
  GET_BG_TRANSACTION_TYPE,
  GET_BG_WALLET_ADD_ON_EXPORT,
  GET_BG_WALLET_TRANSACTION_EXPORT,
  TICKET_PANELTY_SETTLEMENT,
} from "../actions/types";

const initialState = { BgList: [], BgAddOnList: [] };

const BgWalletReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_BG_WALLET_LIST:
      return {
        ...state,
        BgList: payload,
      };
    case Add_BG_WALLET:
      return {
        ...state,
        AddBg: payload,
      };
    case GET_BG_WALLET_STATUS:
      return {
        ...state,
        bgStatus: payload,
      };
    default:
      return state;
  }
};

const BgWalletAddOnReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_BG_WALLET_ADD_ON:
      return {
        ...state,
        BgAddOnList: payload,
      };
    case GET_BG_WALLET_TRANSACTION_EXPORT:
      return {
        ...state,
        BgTransactionExport: payload,
      };
    case GET_BG_WALLET_ADD_ON_EXPORT:
      return {
        ...state,
        BgAddOnExport: payload,
      };
    case GET_BG_WALLET_TRANSACTIONS:
      return {
        ...state,
        getTransactions: payload,
      };
    case Add_BG_WALLET_PANELTY:
      return {
        ...state,
        AddPanelty: payload,
      };
    case GET_BG_TRANSACTION_STATUS:
      return {
        ...state,
        transactionStatus: payload,
      };
    case GET_BG_TRANSACTION_TYPE:
      return {
        ...state,
        transactionType: payload,
      };
    case TICKET_PANELTY_SETTLEMENT:
      return {
        ...state,
        ticketPaneltySettleData: payload,
      };
    default:
      return state;
  }
};

export { BgWalletReducer, BgWalletAddOnReducer };
